<template>
  <!-- 原因  -->
  <div class="carDriving">
    <van-popup
      v-model="show"
      :overlay="false"
      :lock-scroll="false"
      :lazy-render="false"
      class="full-width full-height"
      style="z-index: 1000;"
    >
      <ld-header
        v-if="!orderId"
        @click-left="toggle"
        transparent
        white
      >
        <div
          v-if="carTypeShow && distance"
          class="distanceMarker"
        >
          <ld-icon
            type="iconfenchakou"
            size="12"
          />
          全程{{ distance }}公里 , 预计行驶{{ duration }}分钟
        </div>
        <div
          v-else-if="dissolutionShow"
          class="distanceMarker"
        >
          <ld-icon
            type="iconfenchakou"
            size="12"
          />
          全程{{ dissolution }}公里 , 预计行驶{{ durationItem }}分钟
        </div>
        <img
          slot="left"
          class="custom-back"
          src="~Assets/images/back.png"
        >
      </ld-header>
      <!-- 地图代码 -->
      <div
        id="carDrivingMap"
        style="position: absolute;
              width: 100vw;
              height: calc(100vh - 225px);
              top: 0;"
      />

      <template v-if="show">
        <van-popup
          v-model="carTypeShow"
          position="bottom"
          :overlay="false"
          :close-on-popstate="true"
          :close-on-click-overlay="false"
          safe-area-inset-bottom
          round
          :style="{
            padding: '8px',
            overflow: 'initial'
          }"
        >
          <van-row class="popup-float">
            <van-col :span="jsycData.useType == 8 ? 6 : 10">
              <van-button size="small">
                {{
                  jsycData.useType == 8 ?
                    '现在用车' : jsycData.startTimeName
                }}
                <van-icon
                  name="arrow"
                  class="vertical-middle gray"
                />
              </van-button>
            </van-col>
            <van-col span="12">
              <van-button
                size="small"
                icon="contact"
                @click="openEmplist"
              >
                <span> {{ jsycData.empName || '选择乘车人' }}</span>
              </van-button>
            </van-col>
          </van-row>

          <van-tabs
            class="carTypeList_tabs"
            v-model="carTypeActive"
            animated
            swipeable
            sticky
            :ellipsis="false"
          >
            <van-tab
              v-for="(carType, i) in jsycData.carTypeList"
              :key="carType.vehicleTypeId"
              :name="i"
              :badge="carType.badge"
            >
              <template #title>
                <div class="carTabDesc text-center">
                  <p class="font-bold">
                    {{ carType.vehicleTypeName | substring(0, 2) }}
                  </p>
                  <p class="font10">
                    <span v-if="carTypeActive === i">{{ carType.personNum }}人·{{ carType.luggageNum }}行李</span>
                    <span v-else>{{ carType.detailBeanList[0].salePrice + carType.detailBeanList[0].serviceFee | fixed(0) }} 元起</span>
                  </p>
                </div>

                <van-image
                  :src="carType.coverUrl"
                  width="88"
                  height="60"
                />
              </template>

              <van-field
                v-for="carBean in carType.detailBeanList"
                name="checkbox"
                @click="checkCar(carType, carBean)"
                :key="carBean.productId"
                clickable
                readonly
                input-align="right"
              >
                <template #label>
                  <img
                    class="round-sm"
                    width="32"
                    :src="carBean.priceFromUrl"
                  >
                  <div class="label_name inline-block">
                    {{ carBean.priceFromName }} <br>
                    <van-tag plain>
                      车辆消毒
                    </van-tag>
                  </div>
                </template>
                <template #input>
                  <van-tag
                    v-show="iswb(carBean)"
                    type="danger"
                  >
                    {{ $t('K303','违') }}
                  </van-tag>
                  &nbsp;&nbsp;
                  <span class="font12">
                    约
                    <span class="font20 font-bold">{{ carBean.salePrice + carBean.serviceFee | fixed(0) }}</span>
                    元
                  </span>
                </template>
                <template #right-icon>
                  <van-checkbox
                    v-model="carBean.checked"
                    :disabled="!canbook(carBean)"
                  />
                </template>
              </van-field>
            </van-tab>
          </van-tabs>


          <ldButton
            main
            :disabled="!submitLabel"
            size="lg"
            @click.native="book"
          >
            {{ submitLabel || '请选择车型' }}
          </ldButton>
        </van-popup>

        <van-popup
          v-model="carDetailShow"
          position="bottom"
          :overlay="false"
          :close-on-popstate="true"
          :close-on-click-overlay="false"
          safe-area-inset-bottom
          round
          :style="{
            overflow: 'initial'
          }"
        >
          <order-detail
            :data="detail"
            @getDetail="query"
            @loading="orderLoading"
            @waiting="orderWaiting"
            @taking="orderTaking"
            @complete="orderComplete"
            @cancel="orderCancel"
            @reset="reset()"
          />
        </van-popup>
      </template>
    </van-popup>

    <emp-list
      ref="empList"
      cplx="10906"
      element=".carDriving"
      radio
      @radioSelected="radioSelected"
    />

    <violate-list
      cplx="10906"
      ref="violateList"
      :violate="clzcStr"
      @selected="() => book()"
    />
  </div>
</template>

<script>
import { Popup, Tabs, Tab, Image, Field, Checkbox, Tag, Button } from 'vant'
import ldButton from 'Common/ldButton'
import empList from 'Components/ldEmpList'
import orderDetail from 'Views/Car/carOrder/jsycDetailPopup'
import { mapGetters } from 'vuex'

import car_icon from 'Assets/images/car/car.png'

import start_icon from 'Assets/images/car/map_start.png'
import end_icon from 'Assets/images/car/map_end.png'

import AMap from './AMap'
import { getSysType } from '@/common/utils/plus'
import { formatDate, secondsToMins } from '@/business/utils/dateUtil'
import { metreToKm } from '@/business/utils/string'
import violateList from 'Components/violateList'
import mixin from './mixin'

// let DriverLonLat = { lng: 113.732013, lat: 23.008647 }

export default {
  name: 'CarDriving',
  mixins: [mixin],
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    orderId: {
      type: String,
      default: ''
    },
  },
  components: {
    [Popup.name]: Popup,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Image.name]: Image,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    [Button.name]: Button,
    ldButton, empList, orderDetail, violateList
  },
  data () {
    return {
      clzcStr: '',
      localOrderId: '',
      show: false,
      wbCar: '',
      carTypeShow: true,
      carDetailShow: false,
      mapInstance: {},
      carTypeActive: 0,
      detail: {},
      distance: 0, // 预估行程距离，单位米
      duration: 0, // 预估行程时间，单位秒

      dissolution:'', // 预估行程距离，单位公里
      durationItem:'',//预估行程时间，单位分钟
      dissolutionShow:true, //行程跟距离是否显示
      loadingTimer: null,
      waitingTimer: null,
      takingTimer: null,
      driverCarMap: null
    }
  },
  computed: {
    ...mapGetters({
      tripType: 'tripType',
      userInfo: 'userInfo',
      jsycData: 'car/jsycData',
      carSearchInfo: 'car/carSearchInfo',
    }),
    submitLabel () {
      let desc = '同时呼叫',
        vehicleTypes = []

      this.jsycData.carCheckList.forEach(carBean => {
        let typeName = carBean.vehicleTypeName.substring(0, 2)
        if (vehicleTypes.indexOf(typeName) === -1) {
          vehicleTypes.push(typeName)
        }
      })

      if (vehicleTypes.length > 1) {
        desc += vehicleTypes.join('+')
      } else if (vehicleTypes.length === 1) {
        if (this.jsycData.carCheckList.length > 1) {
          desc += `${this.jsycData.carCheckList.length}个车型`
        } else {
          desc = '立即叫车'
        }
      } else {
        desc = ''
      }
      return desc
    }
  },
  created () {
    // 默认乘车人是登录人
    this.jsycData.empId = this.userInfo.empInfo.empId
    this.jsycData.empName = this.userInfo.empInfo.empName
    this.jsycData.phoneNumber = this.userInfo.empInfo.phoneNumber || this.userInfo.empInfo.phoneNumber2
  },
  mounted () {
  },
  methods: {
    toggle (params = {}) {
      this.show = params.show

      if (this.show) {
        this.loadMap()

        // 传入ID
        if (params.id) {
          this.queryDeal(params.id)
        } else {
          Object.assign(this.jsycData, {
            departCity: this.data.departCity,
            arriveCity: this.data.arriveCity,
            fromAddressPoi: this.data.fromAddressPoi,
            fromArea: this.data.fromArea,
            fromAddress: this.data.fromAddress,
            fromLon: this.data.fromLon,
            fromLat: this.data.fromLat,
            toAddressPoi: this.data.toAddressPoi,
            toArea: this.data.toArea,
            toAddress: this.data.toAddress,
            toLon: this.data.toLon,
            toLat: this.data.toLat,
            useType: params.useType,
            startTime: params.useType==8?`${formatDate().date} ${formatDate().hm}`:this.data.useTime,
            startTimeName: params.useType==8?`${formatDate().monDayWeek} ${formatDate().hm}`:this.data.useTimeName,
          })

          this.search()
        }
      } else {
        this.reset()
      }
    },
    //使用高德地图API
    loadMap () {
      this.mapInstance = new AMap({
        id: 'carDrivingMap',
        plugins: ['AMap.Geolocation', 'AMap.Driving', 'AMap.MoveAnimation'],//引入API相关配置
        AMapUIPlugins: ['misc/PathSimplifier', '../lib/$'],//引用AMapUI插件
        zoom: 14,
        GeoOffset: [18, 150],
        created: () => {
        },
        completed: () => {
          // 订单详情进来
          if (this.orderId) {
            this.queryDeal(this.orderId)
          }
        },
        error: () => {
          this.$toast.fail('定位失败')
        },
      })
    },
    openEmplist() {
      this.$refs.empList.toggle({ index: 1 })
    },
    radioSelected(info) {
      this.jsycData.empId = info.empId
      info.chName ? this.jsycData.empName = info.chName :	this.jsycData.empName = info.empName
      this.jsycData.phoneNumber = info.phoneNumber
    },
    checkCar (carType, carBean) {
      if (!this.canbook(carBean)) return

      this.$set(carBean, 'checked', !carBean.checked)

      if (!carType.badge) carType.badge = 0
      if (carBean.checked) {
        carType.badge += 1

        carBean.vehicleTypeName = carType.vehicleTypeName
        this.jsycData.carCheckList.push(carBean)
      } else {
        carType.badge -= 1
        let i = this.jsycData.carCheckList.indexOf(carBean)
        this.jsycData.carCheckList.splice(i, 1)
      }
      if (carType.badge === 0) carType.badge = undefined
    },
    // 点击 'pullupMarker'， 改变上车地点地址
    changeFromAddress () {
      this.show = false
      this.$emit('changeFromAddress')
    },
    // 点击 'getdownMarker'， 改变下车地点地址
    changeToAddress () {
      this.$emit('changeToAddress')
    },
    async search () {
      this.data.tripType = this.tripType
      this.data.useType = this.jsycData.useType

      const { data = {} } = await this.$api['carQuery/estimateJsycPrice']({
        'corpId': this.data.corpId,
        'tripType': this.data.tripType,
        'departCity': this.data.departCity,
        'arriveCity': this.data.arriveCity,
        'useType': this.data.useType, // 用车类型 8即时 9预约
        'vehicleTypeId': this.data.vehicleTypeId,
        'fromAddress': this.data.fromAddress,
        'fromLon': this.data.fromLon,
        'fromLat': this.data.fromLat,
        'toAddress': this.data.toAddress,
        'toLon': this.data.toLon,
        'toLat': this.data.toLat,
        'useTime': this.data.useType == 9 ? this.data.useTime : undefined,
        'empId': this.jsycData.empId,
        'ccsqdNo': this.carSearchInfo.Ccsqd.ccsqdNo,
        'fromLocationName': this.data.fromAddressPoi,
        'toLocationName': this.data.toAddressPoi,
        'customerMobile': this.jsycData.phoneNumber,
        'customerName': this.jsycData.empName,
      })

      if (data.typeList && data.typeList.length > 0) {
        this.carTypeShow = true
        this.jsycData.cacheId = data.cacheId
        this.jsycData.carTypeList = data.typeList

        this.distance = metreToKm(data.typeList[0].detailBeanList[0].distance)
        this.duration = secondsToMins(data.typeList[0].detailBeanList[0].duration)

        // 上车地点 点标记
        this.mapInstance.createInfoWindow(this.data.fromAddressName, {
          name: 'pullupMarker',
          position: [this.data.fromLon, this.data.fromLat], // 基点位置
          offset: [-58, -86] // 相对于基点的偏移位置
        }, true).on('click', () => {
          this.changeFromAddress()
        })

        // 下车地点 点标记
        this.mapInstance.createInfoWindow(this.data.toAddressName, {
          name: 'getdownMarker',
          position: [this.data.toLon, this.data.toLat], // 基点位置
          offset: [-58, -86] // 相对于基点的偏移位置
        }, true).on('click', () => {
          this.changeToAddress()
        })
        let {dissolution,duration}= this.mapInstance.distanceOfTwoPosTime([this.data.fromLon, this.data.fromLat],[this.data.toLon, this.data.toLat])
        this.dissolution=dissolution
        this.durationItem=duration

        // 绘制始终点路线 和 标记点
        this.mapInstance.drivingSearch(
          [this.data.fromLon, this.data.fromLat],
          [this.data.toLon, this.data.toLat],
          () => {
            return {
              drivingSearchComplete: (result) => {
                // var route = result.routes[0]
                // var pathOptions = []

                // for (var i = 0, l = route.steps.length; i < l; i++) {
                // 	var step = route.steps[i],
                // 		duration = step.time / step.path.length // 秒

                // 	for (var j = 0, n = step.path.length; j < n; j++) {
                // 		var path = step.path[j]

                // 		pathOptions.push({
                // 			position: [path.lng, path.lat],
                // 			duration: duration * 1000,
                // 		})
                // 	}
                // }

                // console.log(result)
                // console.log(pathOptions)

                // const lng = 113.743119,
                // 	lat = 23.02083


                // // 加载完 AMap.MoveAnimation 插件以后，创建一个 Marker 实例
                // const dirverMarker = this.mapInstance.addMarker({
                // 	name: 'dirverMarker',
                // 	position: [lng, lat],
                // 	icon: car_icon,
                // 	offset: [-13, -36],
                // })

                // dirverMarker.moveAlong(pathOptions, {
                // 	delay: 0
                // })

                // window.dirverMarker = dirverMarker

                this.mapInstance.map.setFitView(null, true, [150, 150, 100, 100])
              }
            }
          }
        )


      } else {
        this.$dialog({message: this.$t('J246', '未查到满足条件的用车产品！')})
        this.toggle()
      }

    },
    // 叫车下单
    async book () {
      this.mapInstance.removeMarker('pullupMarker')
      this.mapInstance.removeMarker('getdownMarker')

      let UseAccount_DebtYck = await this.UseAccount_DebtYck
      if (!UseAccount_DebtYck) {
        this.$dialog({message: '产品未开通，如需开通产品预订请联系客服。'})
        return
      }

      /**
       * 如果没选违背事项，则先去找违背的车型
       */
      if (!this.carSearchInfo.violate) {
        for (let i = 0; i < this.jsycData.carCheckList.length; i++) {
          const car = this.jsycData.carCheckList[i]
          // 差标拦截
          if (this.iswb(car)) {
            this.wbCar = car

            this.clzcStr = this.genViolateDesc(this.wbCar)
            this.$refs.violateList.toggle({ violate: this.clzcStr, cplx: '10906' }) // 选择违背原因
            return
          }
        }
      }

      const params = {
        cacheId: this.jsycData.cacheId,
        orderFrom: getSysType(),
        useType: this.jsycData.useType,
        departCity: this.jsycData.departCity,
        arriveCity: this.jsycData.arriveCity,
        fromAddressPoi: this.jsycData.fromAddressPoi,
        fromArea: this.jsycData.fromArea,
        fromAddress: this.jsycData.fromAddress,
        fromLon: this.jsycData.fromLon,
        fromLat: this.jsycData.fromLat,
        toAddressPoi: this.jsycData.toAddressPoi,
        toArea: this.jsycData.toArea,
        toAddress: this.jsycData.toAddress,
        toLon: this.jsycData.toLon,
        toLat: this.jsycData.toLat,
        startTime: this.jsycData.startTime,
        productId: this.jsycData.carCheckList.map(car => car.productId).join(),
        empId: this.jsycData.empId,
        empName: this.jsycData.empName,
        phoneNumber: this.jsycData.phoneNumber,
        linkEmail: this.userInfo.empInfo.email,
        linkTel: this.jsycData.phoneNumber || this.userInfo.empInfo.phoneNumber,
        linkman: this.userInfo.empInfo.empName,
        reasonCode: this.carSearchInfo.violate.reasonCode, // 违背原因代码
        reasonDesc: this.carSearchInfo.violate.reasonDesc, // 违背原因说明
        violateitem: this.clzcStr, // 违背事项说明
        violateitemCode: this.carSearchInfo.violate.reasonCode || '11109', // 违背事项代码
        tripType: this.tripType,
        ccsqdNo: this.carSearchInfo.Ccsqd.ccsqdNo,
        ext1: this.carSearchInfo.extraInfo
      }

      // const data = { orderId: 'cfba23451eb8437fa2f15b91597f460c' }
      const { data = {} } = await this.$api['carQuery/bookJsyc'](params)

      if (data.orderId) {
        this.carTypeShow = false
        this.carDetailShow = true

        this.localOrderId = data.orderId
        this.query()
        // success...
      }
    },
    queryDeal (id) {
      this.localOrderId = id
      this.show = true
      this.carTypeShow = false
      this.carDetailShow = true
      this.query()
    },
    // 查询订单状态
    async query () {
      try {
        const { data = {} } = await this.$api['carOrder/orderDetail']({ orderId: this.localOrderId })

        // 订单状态: 0已预订 1已派车 2改派中 3司机出发 4司机到达 5开始服务 6结束服务 7已完成 8已取消 9客户消 10派车中
        console.log(data)

        data.phoneNumber = data.phoneNumber && data.phoneNumber.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
        data.startTimeDate = formatDate(data.startTime)
        data.driverAlias = data.driver && `${data.driver.substring(0, 1)}师傅`
        data.fromLon = data.startLng
        data.fromLat = data.startLat
        this.detail = data
      } catch (error) {
        throw error
      }
    },
    // 订单还正在呼叫
    async orderLoading () {
      this.loadingTimer = setInterval(async () => {
        try {
          await this.startDriverLocation()

          // 从订单详进来 需要绘制下 绘制始终点路线 和 标记点
          if (!this.mapInstance.drivingInstance) {
            this.mapInstance.drivingSearch(
              [this.detail.fromLon, this.detail.fromLat],
              [this.detail.toLon, this.detail.toLat]
            )
          }
        } catch (error) {
          throw error
        }
      }, 2 * 1000)
    },
    // 开始派车 - 地图的始和终的路径规划清除，显示司机与上车地点的路径展示和巡航
    async orderWaiting (autoFitView) {
      clearInterval(this.loadingTimer)
      this.mapInstance.pathSetData([])

      this.mapInstance.removeMarker('driverDistanceMarker')

      // 获取司机经纬度
      const { lng, lat } = await this.startDriverLocation()

      if (['1', '3', '4'].indexOf(this.detail.orderStatus) === -1) return

      this.mapInstance.drivingSearch(
        [lng, lat],
        [this.detail.fromLon, this.detail.fromLat],
        () => {
          return {
            options: {
              hideMarkers: true,
              autoFitView: autoFitView ? false : true
            },
            drivingSearchComplete: (result) => {
              const path = AMap.parseRouteToPath(result.routes[0])

              this.mapInstance.addMarker({
                name: 'watingStart',
                position: path[path.length - 1],
                icon: start_icon,
              })

              // 巡航器
              this.mapInstance.pathSetData([{
                name: '路线',
                path: path
              }])

              this.driverCarMap = this.mapInstance.createPathNavigator(0)
              if (this.detail.orderStatus === '4') {
                this.driverCarMap.stop()
              } else {
                this.driverCarMap.start()

                // 上车地点 点标记
                let { content } = this.mapInstance.distanceContent(path, true)//在地图上创建信息窗口司机距离顾客的距离
                console.log('地图上创建信息窗口1',content,path)

                this.mapInstance.createInfoWindow(content, {
                  name: 'driverDistanceMarker',
                  position: [lng, lat], // 基点位置
                  offset: [-78, -48] // 相对于基点的偏移位置
                })
              }

              if (!autoFitView) {
                this.mapInstance.map.setFitView(null, true, [100, 200, 100, 100])
              }

              if (!this.waitingTimer) {
                this.waitingTimer = setInterval(async () => {
                  this.orderWaiting(1)
                }, 5 * 1000)
              }
            }
          }
        }
      )

    },
    async orderTaking (autoFitView) {
      // 清掉司机到客人那的路线巡航器
      clearInterval(this.waitingTimer)
      this.driverCarMap && this.driverCarMap.destroy()
      this.mapInstance.pathSetData([])

      this.mapInstance.removeMarker('watingStart')
      this.mapInstance.removeMarker('driverDistanceMarker')

      const { lng, lat } = await this.startDriverLocation()

      if (['5'].indexOf(this.detail.orderStatus) === -1) return

      // 继续绘制始终点路线
      this.mapInstance.drivingSearch(
        [lng, lat],
        [this.detail.toLon, this.detail.toLat],
        () => {
          return {
            options: {
              hideMarkers: true,
              autoFitView: autoFitView ? false : true
            },
            drivingSearchComplete: (result) => {
              const path = AMap.parseRouteToPath(result.routes[0])

              this.mapInstance.addMarker({
                name: 'takingStart',
                position: [this.detail.fromLon, this.detail.fromLat],
                icon: start_icon,
                anchor: [-9.5, -31]
              })

              this.mapInstance.addMarker({
                name: 'takingEnd',
                position: path[path.length - 1],
                icon: end_icon,
                anchor: [-9.5, -31]
              })

              this.mapInstance.pathSetData([{
                name: '路线',
                path: path
              }])

              this.driverCarMap = this.mapInstance.createPathNavigator(0)
              this.driverCarMap.start()

              let { content } = this.mapInstance.distanceContent(path) //司机距离终点的距离
              console.log('地图上创建信息窗口2',content,path)

              // 下车地点 点标记
              this.mapInstance.createInfoWindow(content, {
                name: 'driverDistanceMarker',
                position: [lng, lat], // 基点位置
                offset: [-78, -48] // 相对于基点的偏移位置
              })

              if (!autoFitView) {
                this.mapInstance.map.setFitView(null, true, [100, 200, 100, 100])
              }

              if (!this.takingTimer) {
                this.takingTimer = setInterval(() => {
                  this.orderTaking(1)
                }, 5 * 1000)
              }
            }
          }
        }
      )

    },
    orderComplete () {
      // 清掉司机始发点的路线巡航器
      this.clearTimer()
      this.driverCarMap && this.driverCarMap.destroy()

      this.mapInstance.pathSetData([])
      this.mapInstance.removeMarker('driverDistanceMarker')
      this.mapInstance.removeMarker('takingStart')
      this.mapInstance.removeMarker('takingEnd')

      this.mapInstance.drivingSearch(
        [this.detail.fromLon, this.detail.fromLat],
        [this.detail.toLon, this.detail.toLat],
        () => {
          return {
            options: {
              map: undefined
            },
            drivingSearchComplete: (result) => {
              const path = AMap.parseRouteToPath(result.routes[0])

              this.mapInstance.addMarker({
                name: 'completeStart',
                position: path[0],
                icon: start_icon,
                anchor: [-9.5, -31]
              })

              this.mapInstance.addMarker({
                name: 'completeEnd',
                position: path[path.length - 1],
                icon: end_icon,
                anchor: [-9.5, -31]
              })

              this.mapInstance.addPolyline({
                name: 'completeLine',
                path: path,
                isOutline: true,
                outlineColor: '#ffeeee',
                borderWeight: 2,
                strokeWeight: 5,
                strokeColor: '#0091ff',
                lineJoin: 'round'
              })

              // 调整视野达到最佳显示区域
              this.mapInstance.map.setFitView(null, true, [150, 150, 100, 100])
            }
          }
        }
      )

    },
    orderCancel () {
      this.orderComplete()
    },
    // 开始定位司机位置
    async startDriverLocation (id) {
      console.log(19)
      this.dissolutionShow=false
      // DriverLonLat.lng += 0.001
      // DriverLonLat.lat += 0.001
      // return DriverLonLat
      try {
        const { data = {} } = await this.$api['carOrder/getDriverLocation']({
          id: id || this.localOrderId,
          resultFlag: '1'
        })

        Object.assign(this.detail, {
          orderStatus: data.orderStatus,
          orderStatusName: data.orderStatusName,
          driver: data.driver,
          scdd: data.scdd,
          xcdd: data.xcdd,
          driverAlias: data.driver && `${data.driver.substring(0, 1)}师傅`,
          driverTel: data.driverTel,
          driverPicUrl: data.driverPicUrl,
          licenseNumber: data.licenseNumber,
          vehiclesDesc: data.vehiclesDesc,
          vehiclesColor: data.vehiclesColor,
          priceFrom: data.priceFrom,
          priceFromName: data.priceFromName,
          fromLon: data.startLng,
          fromLat: data.startLat,
          toLon: data.toLon,
          toLat: data.toLat,
          bearing: data.bearing,
        })

        return {
          lng: data.lng || data.startLng,
          lat: data.lat || data.startLat,
          bearing: data.bearing
        }
      } catch (error) {
        throw error
      }

    },
    reset () {
      this.show = false
      this.detail = {}
      this.carTypeShow = true
      this.carDetailShow = false
      this.jsycData.carTypeList = []
      this.jsycData.carCheckList = []
      if (this.mapInstance.drivingInstance) {
        this.mapInstance.drivingInstance.clear()
      }
      this.mapInstance.destroy()
      this.clearTimer()
      this.$emit('cancel')
    },
    clearTimer (isDetail) {
      clearInterval(this.loadingTimer)
      clearInterval(this.waitingTimer)
      clearInterval(this.takingTimer)
      this.loadingTimer = null
      this.waitingTimer = null
      this.takingTimer = null

      if (isDetail) {
        if (this.mapInstance.drivingInstance) {
          this.mapInstance.drivingInstance.clear()
        }
        this.mapInstance.destroy()
      }
    },

  }
}
</script>

<style lang="less">
.carDriving {
  .popup-float {
    position: absolute;
    top: -40px;
    width: calc(100% - 16px);
  }

  .distanceMarker {
    display: inline-block;
    padding: 6px 12px;
    border-radius: 4px;
    color: @color-text-black;
    box-shadow: 0 2px 2px 1px rgba(0, 0, 0, 0.2);
    background: @color-background-white;
    font-size: @font-size-12;
    margin: 4px;
    font-weight: 300;
  }

  .carInfoMarker {
    min-width: 136px;
    padding: 10px;
    border-radius: @border-radius-md;
    box-shadow: 0px 5px 10px 0px  rgba(0, 0, 0, 0.3);
    background: @color-background-white;
    font-size: @font-size-12;

    .iconright {
      position: absolute;
      right: 11px;
      top: 50%;
      margin-top: -6px;
      font-size: @font-size-12;
    }
  }


  .carTypeList_tabs {

    .van-tabs__wrap {
      height: 96px;
    }

    .van-tab {
      padding: 0;
      line-height: 15px;
    }

    .van-tabs__wrap--scrollable .van-tabs__nav--complete {
      padding-right: 4px;
      padding-left: 4px;
      padding-top: 16px;
    }

    .van-tabs__content {
      margin-top: 12px;

      .van-tab__pane-wrapper {
        height: 240px;
        overflow: scroll;
      }
    }

    .van-field__label {
      width: auto;

      .label_name {
        margin-left: 12px;
      }
    }

    .van-field__body {
      height: 100%;
    }

  }
}
</style>
